import { useState } from "react";
import { useGlobalContext } from "../../hooks/useGlobalContext";
import "../../css/sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronRight, ExpandMore, ExpandLess, ArrowBack } from '@mui/icons-material';

const Sidebar = ({ searching, setSearching, setState, categoryTree }) => {
  const [collapsed, setCollapsed] = useState({});
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [isSlideOut, setIsSlideOut] = useState(false);
  const [isSlideIn, setIsSlideIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleCollapse = (categoryName) => {
    setCollapsed(prevState => ({
      ...prevState,
      [categoryName]: !prevState[categoryName]
    }));
  };

  const handleSlideBack = () => {
    setIsSlideOut(false);
    setIsSlideIn(false);
  };

  const handleSubcategoryClick = (subcategory, e) => {
    e.stopPropagation();
    if (subcategory.children && subcategory.children.length > 0) {
      setSelectedSubcategory(subcategory);
      setIsSlideOut(true);
      setTimeout(() => setIsSlideIn(true), 200);
    } else {
      handleCategoryClick(subcategory);
    }
  };

  const handleCategoryClick = (category) => {
    setSearching({
      ...searching,
      page: 1,
      categorie: category,
      decor: "Tous"
    });
    setState({ isPaneOpenLeft: false });
    if (location.pathname !== '/Produits') {
      navigate('/Produits');
    }
  };

  return (
    <>
      <div className={`sidebar${isSlideOut ? " slide-out" : ""}`}>
        <div className="sidebar-title">
          <div className="title-text">Toutes les catégories</div>
        </div>

        {categoryTree && categoryTree.length > 0 && categoryTree.map((category) => (
          <div className="sidebar-section" key={category._id}>
            <div 
              className="section-title"
              onClick={() => handleCategoryClick(category)}
              style={{ cursor: 'pointer' }}
            >
              {category.Name}
            </div>
            
            {category.children && category.children.length > 0 && (
              <>
                {category.children.slice(0, 4).map((subcategory) => (
                  <div
                    key={subcategory._id}
                    className={`section-link${subcategory.children?.length ? " has-children" : ""}${collapsed[subcategory._id] ? ' collapsed' : ''}`}
                    onClick={(e) => handleSubcategoryClick(subcategory, e)}
                  >
                    <span className="link-text">{subcategory.Name}</span>
                    {subcategory.children?.length > 0 && (
                      <ChevronRight className="arrow" />
                    )}
                  </div>
                ))}
                
                {category.children.length > 4 && (
                  <>
                    <div 
                      className={`collapse ${collapsed[category._id] ? 'show' : ''}`} 
                      id={`collapse-${category._id}`}
                    >
                      {category.children.slice(4).map((subcategory) => (
                        <div
                          key={subcategory._id}
                          className={`section-link${subcategory.children?.length ? " has-children" : ""}${collapsed[subcategory._id] ? ' collapsed' : ''}`}
                          onClick={(e) => handleSubcategoryClick(subcategory, e)}
                        >
                          <span className="link-text">{subcategory.Name}</span>
                          {subcategory.children?.length > 0 && (
                            <ChevronRight className="arrow" />
                          )}
                        </div>
                      ))}
                    </div>
                    <div
                      className={`section-more ${collapsed[category._id] ? 'collapsed' : ''}`}
                      onClick={() => toggleCollapse(category._id)}
                    >
                      {!collapsed[category._id] ? (
                        <>
                          Voir plus
                          <ExpandMore />
                        </>
                      ) : (
                        <>
                          Voir moins
                          <ExpandLess />
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        ))}
      </div>

      <div className={`sidebarSub${isSlideIn ? " slide-in" : ""}`}>
        <div className="sidebar-title" onClick={handleSlideBack}>
          <ArrowBack style={{ color: '#f3f3f3', marginRight: '10px' }} />
          <div className="title-text">Menu principal</div>
        </div>
        <div className="sidebar-section">
          {selectedSubcategory && (
            <>
              <div className="section-title">{selectedSubcategory.Name}</div>
              {selectedSubcategory.children && selectedSubcategory.children.map((subSubcategory) => (
                <div
                  key={subSubcategory._id}
                  className="section-link"
                  onClick={() => {
                    setSearching({
                      ...searching,
                      page: 1,
                      categorie: subSubcategory,
                      decor: "Tous"
                    });
                    setState({ isPaneOpenLeft: false });
                    if (location.pathname !== '/Produits') {
                      navigate('/Produits');
                    }
                  }}
                >
                  {subSubcategory.Name}
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
